import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fd26089"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, "Фильтры", -1))
const _hoisted_2 = { class: "ExpressOrdersFilters__row mt-3" }
const _hoisted_3 = { class: "ExpressOrdersFilters__actions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "ExpressOrdersFilters",
    onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_select, {
        placeholder: "Компания",
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.company_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.company_id) = $event)),
        label: "name",
        "search-by": "name",
        "select-by": "id",
        "infinite-scroll": "",
        "can-deselect": "",
        onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
        onSearch: _ctx.searchCompanies,
        onOptionBySearch: _ctx.unshiftFindedCompany
      }, null, 8, ["loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_select, {
        placeholder: "Пользователь",
        loading: _ctx.data_state.users.is_loading,
        failed: _ctx.data_state.users.is_failed,
        "error-text": "При получении списка пользователей произошла ошибка",
        options: _ctx.data_state.users.list,
        value: _ctx.state.user_id,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.user_id) = $event)),
        label: "email",
        "search-by": "email",
        "select-by": "id",
        "infinite-scroll": "",
        "can-deselect": "",
        onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadUsers(_ctx.data_state.users.pagination.current_page))),
        onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreUsers(_ctx.data_state.users.pagination.current_page + 1))),
        onSearch: _ctx.searchUsers,
        onOptionBySearch: _ctx.unshiftFindedUser
      }, null, 8, ["loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_select, {
        placeholder: "Город",
        loading: _ctx.data_state.cities.is_loading,
        failed: _ctx.data_state.cities.is_failed,
        "error-text": "При получении списка городов произошла ошибка",
        options: _ctx.data_state.cities.list,
        value: _ctx.state.city_id,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.city_id) = $event)),
        label: "name",
        "search-by": "name",
        "select-by": "id",
        "infinite-scroll": "",
        "can-deselect": "",
        searchable: false,
        onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
        onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
        onSearch: _ctx.searchCities,
        onOptionBySearch: _ctx.unshiftFindedCity
      }, null, 8, ["loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        placeholder: "Статус",
        searchable: false,
        options: _ctx.DELIVERY_STATUSES_OPTIONS,
        value: _ctx.state.status_id,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.status_id) = $event))
      }, null, 8, ["options", "value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.company_name,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.company_name) = $event)),
        placeholder: "Название компании"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.company_bin,
        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.company_bin) = $event)),
        placeholder: "БИН компании"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата от",
        value: _ctx.state.createdAtFrom,
        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.createdAtFrom) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата до",
        value: _ctx.state.createdAtTo,
        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.createdAtTo) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.invoiceNumber,
        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.invoiceNumber) = $event)),
        placeholder: "Номер накладной"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.containerName,
        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.containerName) = $event)),
        placeholder: "Контейнер"
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        placeholder: "Тариф",
        searchable: false,
        "select-by": "value",
        options: _ctx.TRANSPORT_TYPES_OPTIONS,
        value: _ctx.state.transportType,
        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.transportType) = $event)),
        class: "mt-2"
      }, null, 8, ["options", "value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_button, {
        class: "second text small mr-3",
        disabled: _ctx.loading,
        onClick: _ctx.reset
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}